import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { East } from "@mui/icons-material";

const StyledAnchor = styled(Link)`
  color: ${(props) => props.color || "var(--brandColor)"};
  transition: all 0.3s;
  text-decoration: none;
  font-weight: 500;
  background-color: ${(props) => props.bgColor || "transparent"};

  svg {
    font-size: 1.1rem !important;
    margin-left: 4px;
    transition: all 0.3s ease !important;
  }

  &:hover svg {
    margin-left: 8px;
  }
`;

function ArrowButton({ to, children}) {
  return (
    <StyledAnchor to={to}>
      <span>{children}</span>
      <East />
    </StyledAnchor>
  );
}

export default ArrowButton;
